import i18n from '@/plugins/i18n';

export default function (role = 'user',studentProgram={}) {
    let menus = [
        {
            title: i18n.t('graduate_info'),
            title_short: i18n.t('graduate_info'),
            slug: 'graduate_info',
            permission: 'alumni_getalumniprograms',
            show: true,
            showStudent: false
        },
        {
            title: i18n.t('personal_info'),
            title_short: i18n.t('personal_info'),
            slug: 'personal_info',
            permission: 'alumni_getpersonalinformation',
            show: true,
            showStudent: false
        },
        {
            title: i18n.t('job_information'),
            title_short: i18n.t('job_information'),
            slug: 'job_information',
            permission: 'alumni_getworkinginformation',
            show: true,
            showStudent: false
        },
        {
            title: i18n.t('education_info'),
            title_short: i18n.t('education_info'),
            slug: 'education_info',
            permission: 'alumni_geteducations',
            show: true,
            showStudent: false
        },
        {
            title: i18n.t('contact_confirmations'),
            title_short: i18n.t('contact_confirmations'),
            slug: 'contact_confirmations',
            permission: 'alumni_getcommunicationapproveinformation',
            show: true,
            showStudent: false
        },
        {
            title: i18n.t('work_history'),
            title_short: i18n.t('work_history'),
            slug: 'work_history',
            permission: 'alumni_getworks',
            show: true,
            showStudent: false
        }
    ]

    return menus
}


